export const TESTS = {
    GDPR: 'ha_gdpr_banner',
    POLYFILL_SERVICE: 'HA_PTA_LANDING_PolyfillService',
    PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    SLP_TRAFFIC_TEST_AA: 'HA_PTA_LANDING_SLPTrafficTestAA',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    TRIPBOARDS_SAVE_LABEL: 'HA_PTA_LANDING_TripBoardsSaveLabel',
    PILL_FILTER_DESIGN: 'HA_PTA_Landing_Filterdesign',
    HA_NATIVE_ADOPTION_PLACEMENT_HEADER: 'HA_NATIVE_ADOPTION_PLACEMENT_HEADER',
    HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES:
        'HA_PTA_SEARCHBOX_hintTextChoosingDates', // 36021
    VRBO_LANDING_ARIARolesOnSearchForm: 'VRBO_LANDING_ARIArolesOnSearchForm', // 39457
    VRBO_LANDING_GRPCSLPTOSERP: 'VRBO_LANDING_GRPCSLPtoSERP', // 43469
    VRBO_LANDING_Scale_LaunchSearchFromGuestPicker:
        'VRBO_LANDING_scale_launchSearchFromGuestPicker', // 40617
    VRBO_LANDING_SCALE_HINT_TEXT_WHEN_CHOOSING_DATES:
        'VRBO_LANDING_scale_HintTextWhenChoosingDates', // 40753
    VRBO_LANDING_SLP_GLOBAL_MESSAGING_BANNER:
        'VRBO_LANDING_SLPGlobalMessagingBanner', // 40889
    VRBO_LANDING_DESTINATIONLESS_ERROR_ON_SEARCHFORM:
        'VRBO_LANDING_DestinationlessErrorOnSearchForm', // 39471
    VRBO_LANDING_STICKY_SEARCHFORM: 'VRBO_LANDING_stickySearchForm', // 41007
    VRBO_LANDING_SEARCHFORM_DATE_FORMAT: 'VRBO_LANDING_searchFormDateFormat', // 40970,
    VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK:
        'VRBO_LANDING_searchFormDatepickerDayOfWeek', // 40979
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner',
    VRBO_WEB_GLOBAL_MESSAGING_ALERT: 'vrbo_web_global_messaging_alert', // 38174
    HA_PTA_SEARCHFORM_DATES_NUMBER_OF_NIGHTS_SUMMARY:
        'HA_PTA_SEARCHFORM_datesnumberOfNightsSummary', // 36299
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
    VRBO_LANDING_SLPAA: 'Vrbo_landing_SLPAA', // 39889,
    HA_PULSE_REMOVE_AUTO_SAVE: 'ha_pulse_remove_auto_save', // 40819
    HA_PULSE_SELECTABLE_BOARD_TITLE: 'ha_pulse_selectable_board_title', // 41217 cleanup: https://jira.expedia.biz/browse/FRIENDS-4173
    VRBO_LANDING_EGUAS_TYPEAHEAD: 'VRBO_LANDING_EGUAS_typeahead', // 41009
    VRBO_LANDING_NEARBY_DESTINATIONS: 'VRBO_LANDING_nearbyDestinations_EGReco', // 41309
    SERVER_SIDE_TRAFFIC: 'Vrbo_landing_SLPAAServerside', // 41511
    HA_PULSE_CLOSE_SAVE_MODAL: 'ha_pulse_close_save_modal', // 41796
    SLP_ADAPTIVE_LAYOUT_MAB: 'Vrbo_landing_slpadaptivlayoutmab', // 41539
    VRBO_LANDING_DATADOG_FOR_RUM: 'VRBO_LANDING_DataDogForRUM', // 42423
    VRBO_LANDING_MLPTopDestinationsTCS: 'VRBO_LANDING_MLPTopDestinationsTCS', // 41825
    VRBO_LANDING_SLP_HERO_IMAGE_RELEVANCY_ALGO:
        'VRBO_LANDING_SLPHeroImageRelevancyAlgo', // 42535
    VRBO_LANDING_FAQ_TO_TCS: 'VRBO_LANDING_FAQtoTCS', // 42221
    VRBO_LANDING_SLP_PROPERTY_FEED_ALTERNATIVE:
        'VRBO_LANDING_SLPPropertyFeedAlternative', // 43058
};

export const EVALUATE = [
    TESTS.GDPR,
    TESTS.POLYFILL_SERVICE,
    TESTS.PRE_BRAND_TRANSITION,
    TESTS.POST_BRAND_TRANSITION,
    TESTS.HA_TYPEAHEAD_LID_SEARCH,
    TESTS.HA_TYPEAHEAD_TWO_LINE_DISPLAY,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.PILL_FILTER_DESIGN,
    TESTS.HA_NATIVE_ADOPTION_PLACEMENT_HEADER,
    TESTS.HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES,
    TESTS.VRBO_LANDING_ARIARolesOnSearchForm,
    TESTS.VRBO_LANDING_GRPCSLPTOSERP,
    TESTS.VRBO_LANDING_Scale_LaunchSearchFromGuestPicker,
    TESTS.VRBO_LANDING_SCALE_HINT_TEXT_WHEN_CHOOSING_DATES,
    TESTS.VRBO_LANDING_DESTINATIONLESS_ERROR_ON_SEARCHFORM,
    TESTS.VRBO_LANDING_SLP_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_LANDING_SEARCHFORM_DATE_FORMAT,
    TESTS.VRBO_LANDING_STICKY_SEARCHFORM,
    TESTS.VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT,
    TESTS.HA_PTA_SEARCHFORM_DATES_NUMBER_OF_NIGHTS_SUMMARY,
    TESTS.HA_TRAVELER_HEADER_TRAY_MOBILE_APP,
    TESTS.VRBO_LANDING_SLPAA,
    TESTS.HA_PULSE_REMOVE_AUTO_SAVE,
    TESTS.HA_PULSE_SELECTABLE_BOARD_TITLE,
    TESTS.VRBO_LANDING_EGUAS_TYPEAHEAD,
    TESTS.VRBO_LANDING_NEARBY_DESTINATIONS,
    TESTS.HA_PULSE_CLOSE_SAVE_MODAL,
    TESTS.SLP_ADAPTIVE_LAYOUT_MAB,
    TESTS.VRBO_LANDING_DATADOG_FOR_RUM,
    TESTS.VRBO_LANDING_MLPTopDestinationsTCS,
    TESTS.VRBO_LANDING_SLP_HERO_IMAGE_RELEVANCY_ALGO,
    TESTS.VRBO_LANDING_FAQ_TO_TCS,
    TESTS.VRBO_LANDING_SLP_PROPERTY_FEED_ALTERNATIVE,
];

export const hasTest = (abacus, test) => !!(abacus && abacus[test]);

export const getValue = (abacus, test) => {
    const testExists = hasTest(abacus, test);
    if (!testExists) {
        console.warn(`requested value for non-existent test: ${test}`); // eslint-disable-line no-console
    }
    return testExists ? abacus[test].value : 0;
};
